<template>
  <div class="max-w-6xl my-16 mx-auto relative">
    <div v-if="allowFullscreen" class="flex justify-between mb-3">
      <div><span v-if="blockTitle" v-html="blockTitle"></span></div>
      <div class="cursor-pointer" @click="fullscreen = !fullscreen">{{ $t('general', 'fullscreen') }}</div>
    </div>
    <div :style="wrapperStyle" class="relative">
      <div v-if="fullscreen" @click="fullscreen = false" class="opacity-25 hover:opacity-100 fixed top-0 right-0 bg-white text-black py-1 px-6 hover:text-orange-brand rounded-full z-10 m-4 cursor-pointer">{{ $t('general', 'close') }}</div>
      <iframe class="bg-white mx-auto absolute top-0 left-0" :src="row.url" sandbox="allow-scripts" allow="encrypted-media" />
      <figcaption v-if="blockCaption" v-html="blockCaption" class="absolute max-w-6xl mx-auto text-xs mt-2 mb-6 flex-1 mb-16"></figcaption>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseArticleIframeRow',
  data () {
    return {
      fullscreen: false
    }
  },
  props: {
    row: Object
  },
  computed: {
    wrapperStyle () {
      if (this.fullscreen) {
        return {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          'z-index': 50
        }
      } else {
        const ratio = this.row.height / this.row.width * 100
        return {
          width: '100%',
          'padding-top': `${ratio}%`
        }
      }
    },
    blockTitle () {
      const title = this.row.title
      if (!title) return false
      return title.length > 0 && title
    },
    blockCaption () {
      const c = this.row.caption
      if (!c) return false
      return c.length > 0 && c
    },
    allowFullscreen () {
      return this.row.allow_fullscreen
    }
  }
}
</script>

<style lang="stylus" scoped>
  iframe
    width: 100%
    height: 100%
</style>
